/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const FieldWrapper = styled.div({
  paddingTop: token('space.100'),
});

export const FormLabel = styled.label({
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.semibold'),
  color: token('color.text.subtlest'),
  display: 'inline-block',
  marginBottom: token('space.050'),
  marginTop: 0,
  marginRight: token('space.050'),
});

export const FieldRefSelector = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
});

export const FieldRefSelectorDropdown = styled.div({
  flexGrow: 1,
});

export const FieldRefSelectorBuildStatus = styled.div({
  marginLeft: token('space.050'),
});

export const FooterContent = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  width: '100%',
  position: 'relative',
});

export const BranchTypeSelectorTooltipContent = styled.div({
  maxWidth: '264px',
});

export const BranchTypeSelectorIconWrapper = styled.div({
  display: 'inline-block',
});

export const CursorPointer = styled.button({
  backgroundColor: 'transparent',
  border: 'transparent',
  color: 'currentColor',
  cursor: 'pointer',
  padding: 0,
  position: 'relative',
  bottom: token('space.negative.025'),
});

export const BranchTypeSelector = styled.div({
  width: '128px',
});

export const BranchNamePrefix = styled.div({
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '152px',
  margin: `0 ${token('space.025')}`,
  /* AK Tooltip inserts an empty div and we need to target it to properly add ellipsis to the branch name prefix */
  '> div': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const BranchNameError = styled.div({
  maxWidth: '200px',
});

export const DisabledOption = styled.span({
  color: token('color.text.subtlest'),
});
